import React from 'react';

const Refund = () => (
    <div style={{margin:'10px',padding:'10px'}}>
        <h1>Refund policy</h1>
        <p style={{fontSize:"20px"}}>
        Customer satisfaction is our top priority. We do not want our customers to be dissatisfied. We will handle customer complaints properly and resolve the issues quickly. If the order is canceled by the customer 48 hours before the delivery date, the customer will get a full refund. If the order is canceled by the customer less than 12 hours before the delivery date, no refund will be made. If the customer is not satisfied with the item for any reason, the item may be replaced if the recipient can send back the item as delivered within 3 working days, but cannot be refunded. We do not issue any cash refunds. We will gladly replace any product if you are not satisfied.
        </p>
        <p>If you have any concerns regarding our service, contact us:
           <br/> Email us at <span style={{
               color: 'blue',
               textDecoration: 'underline'
           }}>info@dhakafoodieshub.com</span> </p>
    </div>
)
export default Refund;